import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=71e9d7a6&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e9d7a6')) {
      api.createRecord('71e9d7a6', component.options)
    } else {
      api.reload('71e9d7a6', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=71e9d7a6&", function () {
      api.rerender('71e9d7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CaptureModule/Main.vue"
export default component.exports